export const MOVIE_ATTACHMENT_TYPE = 'MOVIE';